/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Title_PhotosInputs */

const en_import_title_photos = /** @type {(inputs: Import_Title_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photos`)
};

const de_import_title_photos = /** @type {(inputs: Import_Title_PhotosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotos`)
};

/**
* | output |
* | --- |
* | "Photos" |
*
* @param {Import_Title_PhotosInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_title_photos = /** @type {((inputs?: Import_Title_PhotosInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Title_PhotosInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_title_photos(inputs)
	return en_import_title_photos(inputs)
});